export default {
  SET_CURRENT_SEASON(state, season) {
    Object.assign(state.currentSeason, season);
  },
  CLEAR_CURRENT_SEASON(state) {
    state.currentSeason.seasonId = null;
    // is the rest of this really necessary?
    state.currentSeason.year = null;
    state.currentSeason.isActive = false;
    state.currentSeason.conferences = null;
    state.currentSeason.divisions = false;
    state.currentSeason.seasonStartDate = null;
    state.currentSeason.seasonEndDate = null;
    state.currentSeason.tournamentStartDate = null;
    state.currentSeason.tournamentPickingOpen = false;
  },
  CLEAR_ALL_SEASONS(state) {
    state.seasonsList.length = 0;
  },
  LOAD_SEASON(state, season) {
    console.group("LOAD_SEASON");
    const newSeason = new Object;
    Object.assign(newSeason, season);

    state.seasonsList.push(newSeason);
    console.info("newSeason = ", newSeason);
    console.info("seasonsList");
    console.table(state.seasonsList);
    console.groupEnd();
  }
};
